import { cn } from "@/lib/utils";
import { LinkIcon } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link } from "./link";

interface MapLinkProps {
  className?: string;
}

export default function MapLink({ className }: MapLinkProps) {
  const { t } = useTranslation();

  const form = useFormContext();

  const lat = form.watch("latitude");
  const lng = form.watch("longitude");

  return (
    <Link
      to={`https://maps.google.com/?q=${lat},${lng}`}
      target="_blank"
      className={cn("flex items-center gap-2", className)}
    >
      <LinkIcon className="w-4 h-4" />
      {t("mapLink.label")}
    </Link>
  );
}
